import DOMPurify from 'isomorphic-dompurify';
import Image from 'next/future/image';
import React from 'react';

import { replaceWithRequiredSiteInfo } from '@/helper/wordReplace';
import { SITE_TITLE, SITE_URL } from '@/utils/constants';

const RightStore = (props: any) => {
  const title = props?.teamTitle;
  const data = props?.teamData;
  const { hostUrl } = props;
  const brandUrl = hostUrl ? `https://${hostUrl}` : SITE_URL;
  const brandTitle = SITE_TITLE;

  return (
    <section className="sv-team-details my-4 my-lg-5">
      <div className="container">
        <h2 className="section-heading">{title}</h2>
        {data &&
          data?.length &&
          data?.map((item: any, index: any) => {
            return (
              <div
                key={index}
                className="row align-items-center mb-4 sv-team-reverse-columns"
              >
                {index % 2 === 0 && (
                  <div className="col-lg-6 col-md-6 col-12">
                    <Image
                      sizes="(max-width: 375px) 300px, (max-width: 576px) 540px, (max-width: 768px) 355px, (max-width: 992px) 475px, (max-width: 1280px) 560px"
                      src={item?.Thumbnail?.data?.attributes?.url}
                      className="w-100 img-fluid team-img"
                      alt={
                        item?.Thumbnail?.data?.attributes?.alternativeText ||
                        item?.Thumbnail?.data?.attributes?.name
                      }
                      width="472"
                      height="275"
                    />
                  </div>
                )}
                <div className="col-lg-6 col-md-6 col-12">
                  <div className="sv-our-team-content">
                    <h3>{item?.Title}</h3>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          replaceWithRequiredSiteInfo(
                            brandTitle,
                            brandUrl,
                            item?.Description
                          )
                        ),
                      }}
                    ></div>
                  </div>
                </div>

                {index % 2 === 1 && (
                  <div className="col-lg-6 col-md-6 col-12">
                    <Image
                      sizes="(max-width: 375px) 300px, (max-width: 576px) 540px, (max-width: 768px) 355px, (max-width: 992px) 475px, (max-width: 1280px) 560px"
                      src={item?.Thumbnail?.data?.attributes?.url}
                      className="w-100 img-fluid team-img"
                      alt={
                        item?.Thumbnail?.data?.attributes?.alternativeText ||
                        item?.Thumbnail?.data?.attributes?.name
                      }
                      width="472"
                      height="275"
                    />
                  </div>
                )}
              </div>
            );
          })}
      </div>
    </section>
  );
};

export default RightStore;
